import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustIndicators = () => {
  const notaryPartners = [
    {
      id: 1,
      name: "Me. N'guessan Aya Odile",
      specialization: "Droit Immobilier & Transactions",
      experience: "20 ans d'expérience",
      office: "Etude - Cocody-Angré",
      certifications: ["Chambre des Notaires CI", "Expert Foncier Certifié"],
      avatar: "#####",
      rating: 4.9,
      completedCases: 1847
    },
    {
      id: 2,
      name: "Me. Frédéric Tatou",
      specialization: "Droit des Affaires & Investissements",
      experience: "18 ans d'expérience",
      office: "Cabinet Traoré - Cocody",
      certifications: ["Notaire Agréé", "Spécialiste Diaspora"],
      avatar: "#######",
      rating: 4.8,
      completedCases: 623
    },
    {
      id: 3,
      name: "Me. Loukou Kouassi Bertin",
      specialization: "Transactions Internationales",
      experience: "18 ans d'expérience",
      office: "Étude Diallo International - Marcory",
      certifications: ["Notaire International", "Expert OHADA"],
      avatar: "#####",
      rating: 4.9,
      completedCases: 1024
    }
  ];

  const certifications = [
    {
      name: "Chambre des Notaires de Côte d'Ivoire",
      description: "Certification officielle des notaires partenaires",
      icon: "Award",
      verified: true
    },
    {
      name: "Registre du Commerce et du Crédit Mobilier",
      description: "Enregistrement légal des activités commerciales",
      icon: "Building",
      verified: true
    },
    {
      name: "Association Professionnelle des Experts Fonciers",
      description: "Expertise reconnue en évaluation immobilière",
      icon: "MapPin",
      verified: true
    },
    {
      name: "Certification ISO 27001",
      description: "Sécurité des systèmes d'information",
      icon: "Shield",
      verified: true
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Adjoua Koffi",
      location: "Abidjan, Cocody",
      role: "Propriétaire",
      content: `Excellente expérience avec Kapital States. Me. Kouamé m'a accompagnée tout au long de l'achat de ma villa. Processus transparent et sécurisé. Je recommande vivement leurs services juridiques.`,
      rating: 5,
      avatar: "#######",
      date: "Décembre 2024"
    },
    {
      id: 2,
      name: "Mamadou Coulibaly",
      location: "Paris, France",
      role: "Investisseur Diaspora",
      content: `Investissement immobilier depuis la France rendu simple grâce à leur équipe. Suivi excellent, documentation claire, et transaction sécurisée. Parfait pour les investisseurs de la diaspora.`,
      rating: 5,
      avatar: "#####",
      date: "Novembre 2024"
    },
    {
      id: 3,
      name: "Aya Touré",
      location: "Abidjan, Plateau",
      role: "Entrepreneuse",
      content: `Service juridique impeccable pour l'acquisition de mes locaux commerciaux. Équipe professionnelle, délais respectés, et prix transparents. Une référence en matière de services notariaux.`,
      rating: 5,
      avatar: "#####",
      date: "Octobre 2024"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        color={index < rating ? "#FCD34D" : "#333333"}
        className={index < rating ? "fill-[#FCD34D]" : "fill-transparent"}
      />
    ));
  };

  return (
    <section className="py-24 bg-transparent border-none outline-none relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* En-tête de section */}
        <div className="text-center mb-20">
          <p className="text-xs font-bold text-brand-gold uppercase tracking-widest mb-3">
            Excellence & Sécurité
          </p>
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-white mb-6 tracking-tight">
            Confiance & Certifications
          </h2>
          <p className="text-lg text-white/50 max-w-2xl mx-auto font-light leading-relaxed">
            Nos partenaires certifiés et nos clients satisfaits témoignent de notre exigence en matière d'expertise juridique.
          </p>
        </div>

        {/* Notary Partners */}
        <div className="mb-24">
          <h3 className="text-2xl font-heading font-bold text-white mb-10 text-center tracking-tight">
            Nos Notaires Partenaires
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {notaryPartners?.map((notary) => (
              <div key={notary?.id} className="bg-[#111111] rounded-3xl p-8 shadow-2xl hover:-translate-y-2 transition-transform duration-500 border-none group">
                <div className="flex items-start space-x-5 mb-6">
                  <div className="w-16 h-16 rounded-full bg-white/5 flex-shrink-0 overflow-hidden border-2 border-white/10 group-hover:border-brand-gold transition-colors">
                    <Image
                      src={notary?.avatar}
                      alt={notary?.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-heading font-bold text-white group-hover:text-brand-gold transition-colors leading-snug mb-1">
                      {notary?.name}
                    </h4>
                    <p className="text-xs text-white/50 font-light mb-2 line-clamp-1">
                      {notary?.specialization}
                    </p>
                    <span className="inline-block bg-brand-gold/10 text-brand-gold text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full">
                      {notary?.experience}
                    </span>
                  </div>
                </div>

                <div className="space-y-4 pt-4 border-t border-white/5">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                      <Icon name="MapPin" size={14} className="text-white/40" />
                    </div>
                    <span className="text-sm text-white/60 font-light">{notary?.office}</span>
                  </div>

                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                      <Icon name="Star" size={14} className="text-brand-gold" />
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-white">
                        {notary?.rating}
                      </span>
                      <span className="text-sm text-white/40 font-light">
                        ({notary?.completedCases} dossiers)
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 pt-2">
                    {notary?.certifications?.map((cert, index) => (
                      <span
                        key={index}
                        className="px-3 py-1.5 bg-white/5 text-white/70 text-xs rounded-lg font-medium"
                      >
                        {cert}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div className="mb-24">
          <h3 className="text-2xl font-heading font-bold text-white mb-10 text-center tracking-tight">
            Certifications Professionnelles
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications?.map((cert, index) => (
              <div key={index} className="bg-[#111111] rounded-3xl p-8 shadow-2xl border-none text-center group hover:bg-white/[0.03] transition-colors">
                <div className="w-16 h-16 bg-white/5 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-inner group-hover:scale-110 transition-transform">
                  <Icon name={cert?.icon} size={24} className="text-brand-gold" />
                </div>
                
                <h4 className="text-base font-heading font-bold text-white mb-3 leading-snug">
                  {cert?.name}
                </h4>
                
                <p className="text-sm text-white/40 font-light mb-6 leading-relaxed">
                  {cert?.description}
                </p>
                
                {cert?.verified && (
                  <div className="inline-flex items-center justify-center space-x-2 bg-emerald-500/10 text-emerald-400 px-4 py-1.5 rounded-full">
                    <Icon name="CheckCircle" size={14} />
                    <span className="text-xs font-bold uppercase tracking-widest">Vérifié</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Client Testimonials */}
        <div>
          <h3 className="text-2xl font-heading font-bold text-white mb-10 text-center tracking-tight">
            Témoignages Clients
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials?.map((testimonial) => (
              <div key={testimonial?.id} className="bg-[#111111] rounded-3xl p-8 shadow-2xl border-none flex flex-col justify-between relative overflow-hidden group">
                {/* Subtle decorative quote icon */}
                <div className="absolute top-4 right-6 opacity-5 group-hover:opacity-10 transition-opacity">
                  <Icon name="MessageSquare" size={80} className="text-brand-gold" />
                </div>

                <div>
                  <div className="flex items-center space-x-1 mb-6">
                    {renderStars(testimonial?.rating)}
                  </div>
                  
                  <p className="text-white/60 font-light leading-relaxed mb-8 italic text-sm md:text-base">
                    "{testimonial?.content}"
                  </p>
                </div>
                
                <div className="flex items-center space-x-4 pt-6 border-t border-white/5">
                  <div className="w-12 h-12 rounded-full bg-white/5 flex-shrink-0 overflow-hidden">
                    <Image
                      src={testimonial?.avatar}
                      alt={testimonial?.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="font-bold text-white text-sm">
                      {testimonial?.name}
                    </p>
                    <p className="text-xs text-white/40 font-light mt-0.5">
                      {testimonial?.role} • {testimonial?.location}
                    </p>
                    <p className="text-[10px] font-bold uppercase tracking-widest text-brand-gold mt-1">
                      {testimonial?.date}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default TrustIndicators;